import React from "react";
import { BACKEND_URL } from "../../lib/api";
import { Image as ImageIcon, Video, FileText } from "lucide-react";

export function iconFor(kind) {
  if (kind === "photo") return <ImageIcon className="h-4 w-4" />;
  if (kind === "video") return <Video className="h-4 w-4" />;
  return <FileText className="h-4 w-4" />;
}

// Rendered thumbnail for a message attachment (photo → <img>, video →
// muted <video> with poster hint, document → generic file icon).
export function Thumb({ a }) {
  const rel = a?.dropbox_url || a?.url;
  const src = rel ? `${BACKEND_URL}${rel}` : null;
  if (!src)
    return (
      <div className="h-full w-full grid place-items-center bg-[var(--mp-dash-bg)] text-[var(--mp-muted)]">
        {iconFor(a?.kind)}
      </div>
    );
  if (a.kind === "photo")
    return <img src={src} alt="" className="h-full w-full object-cover" />;
  if (a.kind === "video")
    return (
      <video
        src={src}
        className="h-full w-full object-cover bg-black"
        muted
        preload="metadata"
      />
    );
  return (
    <div className="h-full w-full grid place-items-center bg-[var(--mp-dash-bg)] text-[var(--mp-muted)]">
      <FileText className="h-8 w-8" />
    </div>
  );
}
